import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 32.8086C7.37647 32.8086 0 25.5762 0 16.6309C0 7.68552 7.37647 0.453125 16.5 0.453125C25.6235 0.453125 33 7.68552 33 16.6309C33 25.5762 25.6235 32.8086 16.5 32.8086ZM16.5 2.35639C8.44412 2.35639 1.94118 8.73232 1.94118 16.6309C1.94118 24.5294 8.44412 30.9053 16.5 30.9053C24.5559 30.9053 31.0588 24.5294 31.0588 16.6309C31.0588 8.73232 24.5559 2.35639 16.5 2.35639Z",
			fill: "#979797"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4527 11.4923C11.7439 10.731 12.035 10.16 12.6174 9.68423C13.1027 9.20842 13.685 8.82776 14.4615 8.54227C15.238 8.25678 16.0145 8.16162 16.888 8.16162C17.5674 8.16162 18.2468 8.25678 18.8292 8.44711C19.4115 8.63744 19.9939 8.92293 20.4792 9.30358C20.9645 9.68423 21.3527 10.16 21.5468 10.731C21.838 11.302 21.935 11.9681 21.935 12.6343C21.935 13.5859 21.7409 14.3472 21.3527 15.0134C20.9645 15.6795 20.3821 16.2505 19.7997 16.9166L18.538 18.1538C18.2468 18.4392 17.9556 18.7247 17.8586 19.0102C17.6645 19.2957 17.5674 19.6764 17.5674 20.057C17.4703 20.4377 17.4703 20.7232 17.4703 21.4845H15.9174C15.9174 20.7232 15.9174 20.4377 16.0145 19.8667C16.1115 19.3909 16.3056 18.9151 16.4997 18.4392C16.6939 18.0586 16.985 17.6779 17.3733 17.2973C17.7615 16.9166 18.2468 16.536 18.7321 15.965C19.2174 15.4892 19.6056 15.0134 19.8968 14.5375C20.188 14.0617 20.3821 13.3956 20.3821 12.8246C20.3821 12.3488 20.285 11.873 20.0909 11.4923C19.8968 11.1117 19.6056 10.731 19.3145 10.4455C19.0233 10.16 18.635 9.96972 18.1497 9.77939C17.6645 9.58907 17.2762 9.4939 16.7909 9.4939C16.1115 9.4939 15.5292 9.58907 15.0439 9.87456C14.5586 10.0649 14.0733 10.4455 13.7821 10.8262C13.4909 11.2068 13.1997 11.6827 13.0056 12.2536C12.8115 12.8246 12.6174 13.1101 12.6174 13.7762H11.0645C11.0645 12.9198 11.1615 12.2536 11.4527 11.4923ZM17.4703 23.2926V25.1958H15.5292V23.2926H17.4703Z",
			fill: "#979797"
		})
	]
});
const ForwardRef = forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
